
/* injects from baggage-loader */

import React, { lazy } from 'react';
import { connect } from 'react-redux';
import { asyncWrapper } from '../../hocs/asyncWrapper';

const Admin = asyncWrapper(lazy(() => import('@admin')));

const AdminWrapper = (props) => {
    return <Admin
        {...props}
    />;
};

const mapStateToProps = (state) => {
    return {
        preferences: state.preferences
    };
};

export default connect(mapStateToProps)(AdminWrapper);